var ko = require('knockout');

// Font Events Manager that keeps track of font events globally on the page
// through the observables associated with the given css font family name and
// font variation description
//
// possible values are: undefined for loading, false for inactive, true for active
//
// fontActive and fontInactive - are called by Typekit.com Javascript
// font event callbacks to update the state of observables associated with the font family
//
// isFontLoaded - is used by Knockout code exclusively
//
var GlobalFontEvents = {
  observables: {},

  // Params: cssFontFamilyname, fontVariationDescription
  //
  // Set an observable to true (active)
  fontActive: function(cssFontFamilyName, fontVariationDescription) {
    var o = GlobalFontEvents.observables[cssFontFamilyName + fontVariationDescription];

    if (o) {
      o(true);
    } else {
      GlobalFontEvents.observables[cssFontFamilyName + fontVariationDescription] = ko.observable(true);
    }
  },

  // Params: cssFontFamilyname, fontVariationDescription
  //
  // Set an observable to false (inactive)
  fontInactive: function(cssFontFamilyName, fontVariationDescription) {
    var o = GlobalFontEvents.observables[cssFontFamilyName + fontVariationDescription];

    if (o) {
      o(false);
    } else {
      GlobalFontEvents.observables[cssFontFamilyName + fontVariationDescription] = ko.observable(false);
    }
  },

  // Params: cssFontFamilyname, fontVariationDescription
  //
  // Set an observable to undefined (loading)
  //
  // Returns: observable used in the Knockout binding
  isFontLoaded: function(cssFontFamilyName, fontVariationDescription) {
    var o = GlobalFontEvents.observables[cssFontFamilyName + fontVariationDescription];

    if (!o) {
      o = GlobalFontEvents.observables[cssFontFamilyName + fontVariationDescription] = ko.observable(undefined);
    }

    return o;
  }
};

module.exports = GlobalFontEvents;
